import React, { useEffect, useState } from "react";
import { Control, useFormContext, useFormState } from "react-hook-form";

import { ControlledInput, ControlledSelect, ControlledToggle } from "../../Common/Controllers";
import { getInputErrorMessage } from "../../Common/Form/service";
import { anticipatedReliefNeedOptions } from "../../constants/dropDownConstants";
import { useRegistrationContext } from "../registrationContext";
import { InputContainer } from "../styles";
import { RegistrationForm } from "../types";

function HospitalInputs({
  animate,
  control,
}: {
  animate: boolean;
  control: Control<{
    hospitalName?: string;
    isCorporateGroup?: boolean;
    selfIdentifiedEnterpriseName?: string;
    anticipatedReliefNeed?: number | null;
  }>;
}) {
  const { registrationContext } = useRegistrationContext();
  // @ts-expect-error TS2322
  const { errors } = useFormState<RegistrationForm>({ control });
  const { watch } = useFormContext<RegistrationForm>();
  const isCorporateGroup = watch("isCorporateGroup");

  const [show, setShow] = useState(animate);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShow(!animate);
    }, 300);
    return () => clearTimeout(timeout);
  }, [animate]);
  return (
    <>
      {show && (
        <InputContainer $animate={animate}>
          <ControlledInput
            name="hospitalName"
            control={control}
            label="Hospital name"
            // @ts-expect-error TS2322
            error={getInputErrorMessage(errors?.hospitalName?.message)}
            defaultValue={registrationContext.hospitalName}
          />
          <span data-testid="corporateGroup">
            <ControlledToggle
              name="isCorporateGroup"
              control={control}
              label="My hospital is part of a Corporate Group"
              defaultValue={registrationContext.isCorporateGroup}
            />
            {isCorporateGroup && (
              <ControlledInput
                name="selfIdentifiedEnterpriseName"
                control={control}
                label="Corporate group name"
                // @ts-expect-error TS2322
                error={getInputErrorMessage(errors?.selfIdentifiedEnterpriseName?.message)}
                defaultValue={registrationContext.selfIdentifiedEnterpriseName}
              />
            )}
          </span>
          <ControlledSelect
            name="anticipatedReliefNeed"
            control={control}
            label="When do you anticipate first needing relief help?"
            options={anticipatedReliefNeedOptions}
            defaultValue={registrationContext.anticipatedReliefNeed}
            // @ts-expect-error TS2322
            error={getInputErrorMessage(errors?.anticipatedReliefNeed?.message)}
          />
        </InputContainer>
      )}
    </>
  );
}

// eslint-disable-next-line no-restricted-exports
export default HospitalInputs;
